var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bkf-action',{attrs:{"tooltip":_vm.$trans('v2.i2m_components.actions.refresh')},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',[_vm._v("\n    refresh\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }